module.exports = __webpack_public_path__ + "img/ff7953f.png";